import React from 'react';
import { DialogContent } from '@bbkAdminComponents/editor-page-overlay/dialog';
import CollapseFormContainer from '@bbkAdminComponents/form/collapse-form-container/collapse-form-container';
import { getPositionDisplayName } from '@bbkAdminRedux/rtkq/placements.utils';
import {
  WarningType,
  type Warning,
  type Warnings,
} from '@bbkAdminUtils/api-client/rest-placement-warnings-api';

export const buildWarningMessage = (warnings: Warnings): React.ReactNode => {
  const renderWarning = (warning: Warning) => {
    switch (warning.type) {
      case WarningType.content: {
        let title = 'Offer';
        if (warning.content.category === 'generic_loss_aversion') {
          title = 'Loss aversion';
        }
        return (
          <div>
            {title}:{' '}
            <span className="tw-font-bold">{warning.content.display_name}</span>
          </div>
        );
      }
      case WarningType.position:
        return (
          <>
            Position:{' '}
            <span className="tw-font-bold">
              {getPositionDisplayName(warning.position)}
            </span>
            {warning.content && (
              <div className="tw-ml-4">
                Content:{' '}
                <span className="tw-font-bold">
                  {warning.content.display_name}
                </span>
              </div>
            )}
          </>
        );
      case WarningType.vanityReason:
        return (
          <>
            Reason:{' '}
            <span className="tw-font-bold">
              {warning.vanityReason.display_name}
            </span>
            {warning.content && (
              <div className="tw-ml-4">
                Content:{' '}
                <span className="tw-font-bold">
                  {warning.content.display_name}
                </span>
              </div>
            )}
          </>
        );
      default:
        return null;
    }
  };
  return (
    <DialogContent>
      <CollapseFormContainer
        classes="CFC-flat-theme mt-0 mb-0"
        title={
          <div className="tw-text-cbryellow-400">
            Warning! A few extra items will be impacted
          </div>
        }
        isOpened={false}
      >
        {warnings.funnel_warnings?.length > 0 && (
          <div className="tw-mb-4 tw-ml-8 tw-mt-2 tw-text-sm tw-text-cbrneutral-500">
            <div className="tw-text-cbryellow-400">
              The following items will be auto-published:
            </div>
            {warnings.funnel_warnings?.map((fw) => (
              <div>
                Page:{' '}
                <span className="tw-font-bold">{fw.funnel.display_name}</span>
                <br />
                {fw.warnings.map((w) => (
                  <div key={fw.funnel.id + Math.random()} className="tw-ml-4">
                    {renderWarning(w)}
                    <div className="tw-mb-1" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
        {warnings.affected_plays?.length > 0 && (
          <div className="tw-mb-4 tw-ml-8 tw-mt-2 tw-text-sm tw-text-cbrneutral-500">
            <div className="tw-text-cbryellow-400">
              The following plays will be affected:
            </div>
            Plays:{' '}
            <span className="tw-font-bold">
              {warnings.affected_plays.map((p) => p.name).join(', ')}
            </span>
          </div>
        )}
      </CollapseFormContainer>
    </DialogContent>
  );
};
